<template>
  <div class="investors-wrapper">
    <div class="info" :class="{'text-right': rightDir}">
      <div class="info__title">
        {{ $t('investInDf') }}
      </div>
      <div class="info__body">
        <div class="info__body-description">
          {{ $t('obtainShare') }}
        </div>
        <ul
          :dir="rightDir ? 'rtl' : 'ltr'"
          :style="{color: colorMain}"
          :class="liColorDots"
        >
          <li>{{ $t('readyWindows') }}</li>
          <li>{{ $t('funcReqLeadingDesignners') }}</li>
          <li>{{ $t('platformFor') }}</li>
          <li>{{ $t('teamSpecialist') }}</li>
        </ul>
        <div class="info__body-boxes">
          <div
            class="info__body-boxes-item"
            :style="{borderColor: colorMain}"
          >
            <div
              class="info__body-boxes-item__price"
              :class="{'info-text-row-reverse': rightDir}"
            >
              {{ $t('sam')
              }}<span
                class="blue"
                :dir="rightDir ? 'rtl' : 'ltr'"
                :style="{color: colorMain}"
                >{{ $t('valueSam') }}</span
              >
            </div>
            <div
              class="info__body-boxes-item__sub"
              :dir="rightDir ? 'rtl' : 'ltr'"
            >
              {{ $t('cagrSam') }}
            </div>
          </div>
          <div
            class="info__body-boxes-item"
            :style="{borderColor: colorMain}"
          >
            <div
              class="info__body-boxes-item__price"
              :class="{'info-text-row-reverse': rightDir}"
            >
              {{ $t('som') }}
              <span
                class="blue"
                :style="{color: colorMain}"
                :dir="rightDir ? 'rtl' : 'ltr'"
                >{{ $t('valueSom') }}</span
              >
            </div>
            <div
              class="info__body-boxes-item__sub"
              :dir="rightDir ? 'rtl' : 'ltr'"
            >
              {{ $t('cagr') }}
            </div>
          </div>
        </div>
        <img
          class="img mobile-image"
          :src="`${staticUrl}/images/cityscape-invest.webp`"
          alt=""
        />
        <div class="form">
          <ui-input
            v-model="form.name"
            :placeholder="$t('name')"
            class="form-input"
          />
          <ui-input
            v-model="form.email"
            :placeholder="$t('email')"
            class="form-input"
            :error="checkEmail"
            @blur="onBlur"
            @input="checkEmail = false"
          />
          <div
            v-if="checkEmail"
            class="emailCheck"
            :class="{'emailCheck-right': rightDir}"
          >
            <!-- Please fill in your email correctly -->
            {{ $t('errorEmail') }}
          </div>
          <ui-input
            v-model="form.phone"
            :direction-right="rightDir ? 'right' : ''"
            :placeholder="$t('phone')"
            class="form-input full"
          />
          <ui-button
            class="info__btn"
            :color="bgBtnColor"
            :disabled="isDisabled"
            @click="submit"
          >
            {{ $t('downloadPitchDeck') }}
          </ui-button>
          <div
            v-if="showMessage"
            class="message"
            :style="{color: colorMain}"
          >
            {{ $t('response') }}
          </div>
        </div>
      </div>
    </div>
    <img
      class="img desktop-image"
      :src="`${staticUrl}/images/cityscape-invest.webp`"
      alt=""
    />
  </div>
</template>

<script lang="ts" setup>
import {api} from '~/plugins/axios';
import {useRuntimeConfig} from '#imports';
import {useDirectionStore} from '~/store/direction.store';
import Logger from '~/helpers/logger';

const logger = Logger.getInstance();

const props = withDefaults(
  defineProps<{
    colorMain?: string;
    bgBtnColor?: 'crimson' | 'light-gray';
    liColorDots?: 'crimson' | 'light-gray';
    emailSubject: string;
  }>(),
  {
    colorMain: 'var(--var-light-green-100)',
    bgBtnColor: 'light-gray',
    liColorDots: 'light-gray',
  },
);

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const direction = useDirectionStore();
const rightDir = computed(() => direction.isRight);

const showMessage = ref(false);
const checkEmail = ref(false);
const form = reactive({
  name: '',
  phone: '',
  email: '',
});

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const isDisabled = computed(() => {
  return !(
    form.email &&
    form.name &&
    form.phone &&
    emailRegex.test(form.email)
  );
});
function onBlur() {
  checkEmail.value = !emailRegex.test(form.email);
}
async function submit() {
  try {
    await api.post(
      'https://dreamflat.design/proxy/profile/send_mail',
      {
        destination: 'b2b@dreamflat.design',
        subject: props.emailSubject,
        body: `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}`,
      },
    );
    logger.info(`[API] success post /proxy/profile/send_mail`);

    form.email = '';
    form.name = '';
    form.phone = '';
    showMessage.value = true;
    setTimeout(() => {
      showMessage.value = false;
    }, 3000);
  } catch (error) {
    logger.error(`[API] try to post /proxy/profile/send_mail: ${error}`);
  }
}
</script>

<style lang="scss" scoped>
.info-text-row-reverse {
  flex-direction: row-reverse;
}
.text-right {
  text-align: right;
  ul {
    padding-right: 24px;
  }
  li::before {
    content: '';
    display: none !important;
  }
  li::after {
    content: '';
    position: absolute;
    top: 20%;
    right: -24px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}

.investors-wrapper {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: $p-5;
  &.row-revesre {
    flex-direction: row-reverse;
  }

  .img {
    display: block;
    border-radius: 16px;
    height: 621px;
    width: 552px;
    object-fit: cover;
  }

  .info {
    max-width: 552px;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 40px;

    &__title {
      color: var(--white-theme-white-000, #fff);
      font-family: Segoe UI;
      font-size: 36px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 43.2px */
      letter-spacing: 1.08px;
    }

    &__body {
      display: flex;
      flex-direction: column;

      &-description {
        margin-top: -10px;
        margin-bottom: 16px;
        height: fit-content;
        color: var(--white-theme-white-000, #fff);
        font-family: Segoe UI;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 22.4px */
        letter-spacing: 0.48px;
      }

      ul {
        list-style: none;
        padding-left: 24px;
        margin-top: 0;

        li {
          position: relative;
          margin-bottom: 8px;
          color: var(--white-theme-white-000, #fff);
          font-family: Segoe UI;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 22.4px */
          letter-spacing: 0.48px;
          &::before {
            content: '';
            position: absolute;
            top: 20%;
            left: -24px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
          }
        }
      }

      &-boxes {
        //height: 120px;
        width: 100%;
        display: flex;
        gap: 24px;

        &-item {
          height: 100%;
          width: 264px;
          padding: 16px;
          border-radius: 16px;
          border: 1px solid #00deba;
          display: flex;
          flex-direction: column;
          gap: 12px;

          &__price {
            display: flex;
            align-items: center;
            color: var(--white-theme-white-000, #fff);
            font-family: Segoe UI;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 133.333% */
            letter-spacing: 0.36px;

            .blue {
              display: block;
              margin-left: auto;
              color: #00deba;
              font-family: Segoe UI;
              font-size: 24px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              letter-spacing: 0.72px;
            }
          }

          &__sub {
            color: var(--white-theme-white-000, #fff);
            font-family: Segoe UI;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%; /* 22.4px */
            letter-spacing: 0.48px;
          }
        }
      }

      .form {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        width: 100%;
        .message {
          width: 100%;
          text-align: center;
          font-family: Segoe UI;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 22.4px */
          letter-spacing: 0.48px;
        }
        .emailCheck {
          width: 50%;
          margin-left: auto;
          margin-top: -7px;
          text-align: center;
          color: var(--white-theme-white-000, #e31e33);
          font-family: Segoe UI;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 22.4px */
          letter-spacing: 0.48px;
          &.emailCheck-right {
            margin-right: auto;
            margin-left: 0;
          }
          @media screen and (max-width: 600px) {
            width: 100%;
          }
          // @media screen  and (max-width: 400px){
          //   margin-right: -5px;
          // }
        }

        &-input {
          width: calc((100% - 16px) / 2);
          height: 44px;
          @media screen and (max-width: 600px) {
            width: 100%;
          }

          &.full {
            width: 100%;
          }
        }

        .info__btn {
          width: 100%;
        }
      }
    }

    @media (max-width: $lg) {
      max-width: 100%;
    }
  }

  .invest-background {
    display: none;
  }

  .mobile-image {
    display: none;
  }
}

@media screen and (max-width: 1160px) {
  .investors-wrapper {
    justify-content: space-between;

    .info {
      width: 55%;
      height: auto;
    }

    .img {
      width: 40%;
    }
  }
}

@media screen and (max-width: 1000px) {
  .investors-wrapper {
    flex-direction: column;
    height: fit-content;
    &.row-revesre {
      flex-direction: column;
    }

    .info {
      width: 100%;

      .info__body {
        &-boxes {
          flex-direction: column;

          &-item {
            width: 100%;
          }
        }
      }
    }

    .img {
      width: 100%;
    }
  }
}

@media screen and (max-width: 600px) {
  .investors-wrapper {
    .info {
      .info__title {
        font-size: 24px;
      }

      .info__body {
        .info__body-description {
          height: auto;
          font-size: 15px;
        }

        ul {
          li {
            font-size: 15px;
          }
        }

        .info__body-boxes {
          &-item {
            &__price {
              font-size: 16px;
            }

            &__sub {
              font-size: 15px;
            }
          }
        }
      }
    }
    .desktop-image {
      display: none;
    }
    .mobile-image {
      display: block;
      margin-top: 24px;
      height: 420px;
    }
  }
}

.light-gray {
  li {
    &::before {
      background: var(--var-light-green-100);
    }
  }
  ::selection {
    background: #00deba; /* Safari */
  }

  ::-moz-selection {
    background: #00deba; /* Firefox */
  }
}
.crimson {
  li {
    &::before {
      background: var(--var-crimson-100);
    }
  }
}
</style>
